;(function () {
  // Your JavaScript here
  console.log('Ellie Active')
  console.log('plans.js')

  document.addEventListener('DOMContentLoaded', hideAccessories)
  document.addEventListener('DOMContentLoaded', checkCartContents)
  document.addEventListener('DOMContentLoaded', getCartContents)

  function hideAccessories() {
    document.querySelectorAll('.maybe_hide_me').forEach(function (el) {
      el.style.display = 'none'
    })
  }

  console.log('i am here')

  var funkyCartCount = 0
  funkyCartCount = checkCartContents()

  function checkCartContents() {
    fetch('/cart.js', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
        throw new Error('Network response was not ok.')
      })
      .then((cartData) => {
        funkyCartCount = parseInt(cartData.item_count)
        return funkyCartCount
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error)
      })
  }

  var myCartContents = ''
  myCartContents = getCartContents()

  function getCartContents() {
    fetch('/cart.js', {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.json()
        }
        throw new Error('Network response was not ok.')
      })
      .then((cartData) => {
        myCartContents = cartData
        return myCartContents
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error)
      })
  }

  function sleep(milliseconds) {
    var start = new Date().getTime()
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break
      }
    }
  }

  var choosePlanForm = document.querySelector('#ChoosePlanAddToCartForm')
  var choosePastCollectionForm = document.querySelector('#ChoosePastCollectionAddToCartForm')
  var chooseProductForm = document.querySelector('#ChooseProductAddToCartForm')
  var staticProductForm = document.querySelector('#ChooseStaticProductAddToCartForm')
  var staticCartForm = document.querySelector('#StaticCartSubmit')

  if(choosePlanForm) {
    choosePlanForm.addEventListener('submit', function (e) {
      e.preventDefault()

      var variant_id = document.querySelector('#prepaidProductChosen')?.value
        ? document.querySelector('#prepaidProductChosen').value
        : document.querySelector(
            '#product_form_variant_subscription_id #variant_id'
          ).value
      var product_collection = document.querySelector(
        '#product_form_variant_subscription_id #collection_info'
      )?.value
      var referrer = localStorage.getItem('referrer')

      var my_bra_size = document.querySelector(
        ".tag-row[aria-type='sports-bra'] input:checked"
      )?.value
      var my_top_size = document.querySelector(
        ".tag-row[aria-type='top'] input:checked"
      )?.value
      var my_bottom_size = document.querySelector(
        ".tag-row[aria-type='bottom'] input:checked"
      )?.value
      var my_jacket_size = document.querySelector(
        ".tag-row[aria-type='jacket'] input:checked"
      )?.value
      var my_gloves_size = document.querySelector(
        ".tag-row[aria-type='gloves'] input:checked"
      )?.value

      var choose_bra =
        document.querySelectorAll(".tag-row[aria-type='sports-bra']").length > 0
      var choose_top =
        document.querySelectorAll(".tag-row[aria-type='top']").length > 0
      var choose_bottom =
        document.querySelectorAll(".tag-row[aria-type='bottom']").length > 0
      var choose_jacket =
        document.querySelectorAll(".tag-row[aria-type='jacket']").length > 0
      var choose_gloves =
        document.querySelectorAll(".tag-row[aria-type='gloves']").length > 0

      var product_id = document.querySelector(
        "#product_form_variant_subscription_id #product_id"
      ).value

      var charge_interval_frequency

      if (
        document.querySelector('#prepaidProductChosen').value &&
        document.querySelector('#prepaidSubscription').checked) {
        charge_interval_frequency = 3
      } else {
        charge_interval_frequency = 1
      }


      var threeItemSelected
      var twoItemSelected

      var chooseThreeOrFiveItems = document.querySelectorAll('.chooseThreeOrFiveItems');
      for (var i = 0; i < chooseThreeOrFiveItems.length; i++) {
        var item = chooseThreeOrFiveItems[i];
        if (item.classList.contains('focus')) {
          var subType = item.querySelector('.subType').value;
          if (subType.indexOf('3') > -1) {
            console.log('3 selected');
            threeItemSelected = true;
          } else if (subType.indexOf('2') > -1) {
            console.log('2 selected');
            twoItemSelected = true;
          }
        }
      }

      console.log(JSON.stringify(twoItemSelected))
      console.log('jackets-ze', my_jacket_size)

      if (twoItemSelected !== true) {
        if (choose_bra && !my_bra_size) {
          alert('Please Choose a Bra Size')
          return false
        }
      }

      if (twoItemSelected !== true) {
        if (choose_top && !my_top_size) {
          alert('Please Choose a Top Size')
          return false
        }
      }

      if (choose_bottom && !my_bottom_size) {
        alert('Please Choose a Leggings Size')
        return false
      }

      if (twoItemSelected !== true) {
        if (choose_jacket && !my_jacket_size) {
          alert('Please Choose a Jacket Size')
          return false
        }
      }

      if (
        choose_gloves &&
        !my_gloves_size &&
        !threeItemSelected &&
        !twoItemSelected
      ) {
        alert('Please Choose a Gloves Size')
        return false
      }

      // TODO: one-off purchcase
      var one_off_product = document.querySelector('#product_one_off')?.value
      var data1

      if (one_off_product) {
        data1 = {
          quantity: 1,
          id: variant_id,
          'properties[shipping_interval_frequency]': 1,
          'properties[shipping_interval_unit_type]': 'Months',
          'properties[product_collection]': product_collection,
          'properties[charge_interval_frequency]': charge_interval_frequency, //TODO: prepaid purchase added 9/10/18
          'properties[charge_interval_unit_type]': 'Months',
          'properties[main-product]': true,
          'properties[leggings]': my_bottom_size,
          'properties[tops]': my_top_size,
          'properties[sports-bra]': my_bra_size,
          'properties[sports-jacket]': my_jacket_size,
          'properties[gloves]': my_gloves_size,
          'properties[referrer]': referrer,
          'properties[product_id]': product_id, //TODO: prepaid
          'properties[number_charges_until_expiration]': 1,
        }
      } else {
        data1 = {
          quantity: 1,
          id: variant_id,
          'properties[shipping_interval_frequency]': 1,
          'properties[shipping_interval_unit_type]': 'Months',
          'properties[product_collection]': product_collection,
          'properties[charge_interval_frequency]': charge_interval_frequency, //TODO: prepaid purchase added 9/10/18
          'properties[charge_interval_unit_type]': 'Months',
          'properties[main-product]': true,
          'properties[leggings]': my_bottom_size,
          'properties[tops]': my_top_size,
          'properties[sports-bra]': my_bra_size,
          'properties[sports-jacket]': my_jacket_size,
          'properties[gloves]': my_gloves_size,
          'properties[referrer]': referrer,
          'properties[product_id]': product_id, //TODO: prepaid
        }
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data1),
      })
        .then((response) => {
          if (response.ok) {
            if (funkyCartCount == 0) {
              var custid = document.getElementById('cust_id').value
              var custemail = document.getElementById('cust_email').value
              var customer_param = ''
              if (custid == '' || custemail == '') {
                customer_param = ''
              } else {
                customer_param =
                  'customer_id=' + custid + '&customer_email=' + custemail
              }
              function get_cookie(name) {
                return (document.cookie.match('(^|; )' + name + '=([^;]*)') ||
                  0)[2]
              }
              do {
                token = get_cookie('cart')
              } while (token == undefined)

              // var myshopify_domain='elliestaging.myshopify.com';
              var myshopify_domain = 'ellie.com'
              try {
                var ga_linker = ga.getAll()[0].get('linkerParam')
              } catch (err) {
                var ga_linker = ''
              }
              checkout_url =
                'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' +
                myshopify_domain +
                '&cart_token=' +
                token +
                '&' +
                ga_linker +
                '&' +
                customer_param
              // window.location = checkout_url;
              window.location = '/cart'
            } else {
              window.location = '/cart'
            } //end if funkyCartCount == 0
          } else {
            throw new Error('Network response was not ok')
          }
        })
        .catch((error) => {
          alert(
            'Sorry there was an error, please call customer service: 1 (844) 338-5044'
          )
        })
      const prodChoiceSubmit = document.querySelector('#prod-choice-submit');
      prodChoiceSubmit.disabled = true;
      sleep(3000)
    })
  }

  if(choosePastCollectionForm) {
    choosePastCollectionForm.addEventListener('submit', function (e) {
      e.preventDefault()
      console.log('submitting...')

      var subscription_id = document.querySelector(
        '#product_form_variant_subscription_id #subscription_id'
      ).value
      var variant_id = document.querySelector('#prepaidProductChosen').value
        ? document.querySelector('#prepaidProductChosen').value
        : document.querySelector(
            '#product_form_variant_subscription_id #variant_id'
          ).value
      var sku_id = document.querySelector(
        '#product_form_variant_subscription_id #sku_id'
      ).value
      var product_collection = document.querySelector(
        '#product_form_variant_subscription_id #collection_info'
      ).value
      var referrer = localStorage.getItem('referrer')

      var my_bra_size = document.querySelector(
        ".tag-row[aria-type='sports-bra'] input:checked"
      ).value
      var my_top_size = document.querySelector(
        ".tag-row[aria-type='top'] input:checked"
      ).value
      var my_bottom_size = document.querySelector(
        ".tag-row[aria-type='bottom'] input:checked"
      ).value
      var my_jacket_size = document.querySelector(
        ".tag-row[aria-type='jacket'] input:checked"
      ).value
      var my_gloves_size = document.querySelector(
        ".tag-row[aria-type='gloves'] input:checked"
      ).value

      var choose_bra =
        document.querySelectorAll(".tag-row[aria-type='sports-bra']").length > 0
      var choose_top =
        document.querySelectorAll(".tag-row[aria-type='top']").length > 0
      var choose_bottom =
        document.querySelectorAll(".tag-row[aria-type='bottom']").length > 0
      var choose_jacket =
        document.querySelectorAll(".tag-row[aria-type='jacket']").length > 0
      var choose_gloves =
        document.querySelectorAll(".tag-row[aria-type='gloves']").length > 0


      console.log('rvhandle', document.querySelector('.product_section').getAttribute('data-rv-handle'));
      var productSection = document.querySelector('.product_section');
      var twoItemOneTimePurchase = productSection.getAttribute('data-rv-handle').indexOf('2-item') > -1 ? true : false;
      if (twoItemOneTimePurchase === false) {
        if (choose_bra && !my_bra_size) {
          alert('Please Choose a Bra Size')
          return false
        }
      }

      if (choose_top && !my_top_size) {
        alert('Please Choose a Top Size')
        return false
      }
      if (choose_bottom && !my_bottom_size) {
        alert('Please Choose a Leggings Size')
        return false
      }
      if (choose_jacket && !my_jacket_size) {
        alert('Please Choose a Jacket Size')
        return false
      }
      if (choose_gloves && !my_gloves_size) {
        alert('Please Choose a Gloves Size')
        return false
      }

      var data1 = {
        quantity: 1,
        id: variant_id,
        'properties[shipping_interval_frequency]': 1,
        'properties[shipping_interval_unit_type]': 'Months',
        'properties[product_collection]': product_collection,
        'properties[charge_interval_frequency]': 1,
        'properties[charge_interval_unit_type]': 'Months',
        'properties[main-product]': true,
        'properties[leggings]': my_bottom_size,
        'properties[tops]': my_top_size,
        'properties[sports-bra]': my_bra_size,
        'properties[sports-jacket]': my_jacket_size,
        'properties[gloves]': my_gloves_size,
        'properties[number_charges_until_expiration]': 1,
        'properties[referrer]': referrer,
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data1)
      })
        .then(response => {
          if (response.ok) {
            if (funkyCartCount == 0) {
              var custid = document.getElementById('cust_id').value
              var custemail = document.getElementById('cust_email').value
              var customer_param = ''
              if (custid == '' || custemail == '') {
                customer_param = ''
              } else {
                customer_param =
                  'customer_id=' + custid + '&customer_email=' + custemail
              }
              function get_cookie(name) {
                return (document.cookie.match('(^|; )' + name + '=([^;]*)') ||
                  0)[2]
              }
              do {
                token = get_cookie('cart')
              } while (token == undefined)

              // var myshopify_domain='elliestaging.myshopify.com';
              var myshopify_domain = 'ellie.com'
              try {
                var ga_linker = ga.getAll()[0].get('linkerParam')
              } catch (err) {
                var ga_linker = ''
              }
              checkout_url =
                'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' +
                myshopify_domain +
                '&cart_token=' +
                token +
                '&' +
                ga_linker +
                '&' +
                customer_param
              // window.location = checkout_url;
              window.location = '/cart'
            } else {
              window.location = '/cart'
            } //end if funkyCartCount == 0
          } else {
            throw new Error('Network response was not ok')
          }
        })
        .catch(error => {
          alert(
            'Sorry there was an error, please call customer service: 1 (844) 338-5044'
          )
        })

      const prodChoiceSubmit = document.querySelector('#prod-choice-submit');
      prodChoiceSubmit.disabled = true;
      sleep(3000)
    })()
  }

  if(staticCartForm) {
    staticCartForm.addEventListener('submit', function (e) {
      e.preventDefault()
  
      var formData = myCartContents
      var custid = document.getElementById('cust_id').value
      var custemail = document.getElementById('cust_email').value
      var customer_param = ''
      if (custid == '' || custemail == '') {
        customer_param = ''
      } else {
        customer_param = 'customer_id=' + custid + '&customer_email=' + custemail
      }
      function get_cookie(name) {
        return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
      }
      do {
        token = get_cookie('cart')
      } while (token == undefined)
  
      // var myshopify_domain='elliestaging.myshopify.com';
      var myshopify_domain = 'ellie.com'
      try {
        var ga_linker = ga.getAll()[0].get('linkerParam')
      } catch (err) {
        var ga_linker = ''
      }
  
      checkout_url =
        'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' +
        myshopify_domain +
        '&cart_token=' +
        token +
        '&' +
        ga_linker +
        '&' +
        customer_param
  
      // window.location = checkout_url;
      // window.location = "/cart"
      window.location = '/checkout'
    })
  }

  if(staticProductForm) {
    staticProductForm.addEventListener('submit', function (e) {
      e.preventDefault()
  
      var product_title = document.querySelector('.product-title').value;
      var shopify_product_id = document.querySelector('#product_hidden_form #shopify_product_id').value;
      var price = document.querySelector('#product_hidden_form #shopify_product_price').value;
      var quantity = document.querySelector('.quantity-input').value;
      var size = document.querySelector('.option-value-input:checked').value;
      var shopify_variant_id;
      var referrer = localStorage.getItem('referrer');

      document.querySelectorAll('.product-options select[name="id"] option').forEach(function(option) {
        var optionText = option.innerHTML.split(' - ')[0].split(' /')[0].trim(); // edited to account for color variant 5-7-2018

        if (optionText == size) {
          shopify_variant_id = option.value;
          return false;
        }
      });
      // console.log('shopify_variant_id', shopify_variant_id);
  
      var formData = {
        quantity: quantity,
        id: shopify_variant_id, //?? or variant?
        product_title: product_title,
        price: price,
        shopify_variant_id: shopify_variant_id,
        'properties[shipping_interval_frequency]': 1,
        'properties[shipping_interval_unit_type]': 'Months',
        'properties[charge_interval_frequency]': 1,
        'properties[charge_interval_unit_type]': 'Months',
        'properties[order_interval_frequency]': 1,
        'properties[order_interval_unit]': 'month',
        'properties[number_charges_until_expiration]': 1,
        'properties[referrer]': referrer,
      }
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response.ok) {
          document.querySelector('.product-form-inline-atc-button').disabled = true;
          if (funkyCartCount == 0) {
            var custid = document.getElementById('cust_id').value
            var custemail = document.getElementById('cust_email').value
            var customer_param = ''
            if (custid == '' || custemail == '') {
              customer_param = ''
            } else {
              customer_param =
                'customer_id=' + custid + '&customer_email=' + custemail
            }
            function get_cookie(name) {
              return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
            }
            do {
              token = get_cookie('cart')
            } while (token == undefined)
  
            // var myshopify_domain='elliestaging.myshopify.com';
            var myshopify_domain = 'ellie.com'
            try {
              var ga_linker = ga.getAll()[0].get('linkerParam')
            } catch (err) {
              var ga_linker = ''
            }
  
            checkout_url =
              'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' +
              myshopify_domain +
              '&cart_token=' +
              token +
              '&' +
              ga_linker +
              '&' +
              customer_param
  
            // window.location = checkout_url;
            window.location = '/cart'
          } else {
            window.location = '/cart'
          }
        } //end if funkyCartCount == 0
      })
      .catch(error => {
        // console.log('data.status', data.status, data.responseText)
        if (data.status == 422) {
          alert(data.responseJSON.description)
        } else {
          alert(
            'Sorry there was an error, please call customer service: 1 (844) 338-5044'
          )
          return false
        }
      })
    })
  }

  if(chooseProductForm) {
    chooseProductForm.addEventListener('submit', function (e) {
      e.preventDefault()
  
      var product_title = document.querySelector('.product-title').value;
      var shopify_product_id = document.querySelector('#product_hidden_form #shopify_product_id').value;
      var price = document.querySelector('#product_hidden_form #shopify_product_price').value;
      var quantity = document.querySelector('.quantity-input').value;
      var size = document.querySelector('.option-select-input').value;
      var shopify_variant_id;
      var options = document.querySelectorAll('.product-options select[name="id"] option');
      options.forEach(function(option) {
        if (option.innerHTML.indexOf(size) > -1) {
          shopify_variant_id = option.value;
        }
      });
      var referrer = localStorage.getItem('referrer');
      // console.log('shopify_variant_id', shopify_variant_id);
  
      var formData = {
        quantity: quantity,
        id: shopify_variant_id, //?? or variant?
        product_title: product_title,
        price: price,
        shopify_variant_id: shopify_variant_id,
        'properties[shipping_interval_frequency]': 1,
        'properties[shipping_interval_unit_type]': 'Months',
        'properties[charge_interval_frequency]': 1,
        'properties[charge_interval_unit_type]': 'Months',
        'properties[referrer]': referrer,
      }
  
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (funkyCartCount == 0) {
          var custid = document.getElementById('cust_id').value
          var custemail = document.getElementById('cust_email').value
          var customer_param = ''
          if (custid == '' || custemail == '') {
            customer_param = ''
          } else {
            customer_param =
              'customer_id=' + custid + '&customer_email=' + custemail
          }

          function get_cookie(name) {
            return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
          }
          do {
            token = get_cookie('cart')
          } while (token == undefined)

          // var myshopify_domain='elliestaging.myshopify.com';
          var myshopify_domain = 'ellie.com'
          try {
            var ga_linker = ga.getAll()[0].get('linkerParam')
          } catch (err) {
            var ga_linker = ''
          }
          checkout_url =
            'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' +
            myshopify_domain +
            '&cart_token=' +
            token +
            '&' +
            ga_linker +
            '&' +
            customer_param
          // window.location = checkout_url;
          window.location = '/cart'
        } else {
          window.location = '/cart'
        } //end if funkyCartCount == 0

      })
      .catch(error => {
        alert(
          'Sorry there was an error, please call customer service: 1 (844) 338-5044'
        )
      
      })
    })
  }
})()
